import EditAvatar from '@bz/account/src/routes/setting/account-info/EditAvatar';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    dialog: {
      get title() {
        return t('Edit profile info');
      },
    },
  },
};

export default EditAvatar;
